import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

const Content = ({ professionalName, children }) => (
  <div className="Content">
    <div className="inner">
      {children}
    </div>
  </div>
)

Content.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Content



// WEBPACK FOOTER //
// ./src/components/Content/index.js